var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.2821 5.88263L7.00124 3.16468L9.72149 5.88484L11.3028 4.3025L7.00124 0L2.69971 4.3014L4.2821 5.88263Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.00024L1.58181 5.41848L3.16362 7.00024L1.58181 8.582L0 7.00024Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28236 8.11732L7.0015 10.8364L9.72175 8.11621L11.3041 9.69634L11.303 9.69744L7.0015 13.9999L2.69997 9.69966L2.69775 9.69744L4.28236 8.11732Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8364 7.00061L12.4182 5.41885L14 7.00061L12.4182 8.58237L10.8364 7.00061Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60575 6.99948L7.00125 5.39392L5.81473 6.5804L5.67761 6.71641L5.39674 6.99727L5.39453 6.99948L5.39674 7.0028L7.00125 8.60615L8.60575 7.00059L8.60686 6.99948H8.60575Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/binance.46307373c547c943efa3fbe0268c3578.svg";
export { ForwardRef as ReactComponent };